// Project
import request from "../request";

export const getFeatureFlags = async (env) => {
	const response = await request({
		url: `${env}/feature-flags`,
	});

	return response.data;
};

export const getFeatureFlag = async (env, slug) => {
	const response = await request({
		url: `${env}/feature-flags/${slug}`,
	});

	return response.data;
};

export const getCompanyFeatureFlags = async (env, companyId) => {
	const response = await request({
		url: `${env}/companies/${companyId}/feature-flags`,
	});

	return response.data;
};

export const getFeatureFlagMatrix = async (env, companyId) => {
	const response = await request({
		url: `${env}/feature-flags/matrix`,
	});

	return response.data;
};
